import {Avatar, Badge, Button, Col, Input, Popconfirm, Row, Table} from 'antd';
import {inject, observer} from 'mobx-react';
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {RouteComponentProps} from 'react-router';
import {Link} from 'react-router-dom';
import Card, {CardBody, CardHeader} from '../../components/Card';
import Layout, {Main} from '../../components/Layout';
import {Auth} from '../../models/authModel';
import {ListingDetailModelType} from '../../models/ListingDetailModel';
import {RolesListModelType} from '../../models/RolesListModel';
import './index.css';

// tslint:disable
interface WithInjectedProps extends RouteComponentProps<{listingId: string}> {
  listingDetail: ListingDetailModelType;
  auth: Auth;
  rolesList: RolesListModelType;
}

@inject('listingDetail', 'rolesList')
@observer
class ListingDetail extends React.Component<RouteComponentProps, {}> {
  componentDidMount() {
    this._withInjectedProps.listingDetail.getListing(this._listingId);
    this._withInjectedProps.rolesList.loadEntries('team');
  }

  private get _listingId() {
    return Number(this._withInjectedProps.match.params.listingId);
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  render() {
    const {isLoading, listing} = this._withInjectedProps.listingDetail;

    return (
      <React.Fragment>
        <Helmet>
          <title>Listing Detail</title>
        </Helmet>
        <Layout>
          <Main>
            <Card>
              <CardHeader>Listing Detail</CardHeader>
              {isLoading ? this._loading() : this._detailListing(listing)}
            </Card>
          </Main>
        </Layout>
      </React.Fragment>
    );
  }

  private _detailListing(listing: any) {
    return listing ? (
      <React.Fragment>
        <CardBody>
          {this._renderBasicInfo(listing)}
          {this._renderListingMembers(listing)}
          {this._renderTeamMembers()}
        </CardBody>
      </React.Fragment>
    ) : null;
  }

  private _renderTeamMembers() {
    const {isLoadingTeam} = this._withInjectedProps.listingDetail;
    const {team} = this._withInjectedProps.listingDetail;
    return (
      <React.Fragment>
        <h3 style={{fontSize: 20, fontWeight: 'bold', marginTop: 20}}>
          List Members Of Team <Badge count={team ? team.members.length : 0} />
        </h3>
        <Row>
          <Table
            columns={this._dataHeaderTableTeamMembers()}
            dataSource={this._cvtDataTeamMembers()}
            loading={isLoadingTeam}
          />
        </Row>
      </React.Fragment>
    );
  }

  private _dataHeaderTableTeamMembers() {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Avatar',
        dataIndex: 'avatar',
        key: 'avatar'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action'
      }
    ];
  }

  private _cvtDataTeamMembers() {
    const {team} = this._withInjectedProps.listingDetail;
    if (team) {
      const listMembers = Array.from(team.members.values());
      return listMembers.map((member: any, idex: number) => {
        return this._itemMemberTeamTable(member);
      });
    }
    return [];
  }

  private _itemMemberTeamTable(member: any) {
    const {id, firstName, lastName, avatar} = member;
    return {
      key: id,
      id: id,
      avatar: <Avatar shape="square" src={avatar} />,
      name: `${firstName} ${lastName}`,
      action: <Link to={`/users/${id}`}>View Detail</Link>
    };
  }

  private _renderListingMembers(listing: any) {
    return (
      <React.Fragment>
        <h3 style={{fontSize: 20, fontWeight: 'bold', marginTop: 20}}>
          Members Manage Listing
          <Badge count={listing.members.size} />
        </h3>

        {this._renderAssignMember()}
        <Row>
          <Table
            columns={this._dataHeaderTableMembers()}
            dataSource={this._cvtDataMembers(listing.members)}
          />
        </Row>
      </React.Fragment>
    );
  }

  private _renderAssignMember() {
    const {isLoadingAddNewMember} = this._withInjectedProps.listingDetail;
    return (
      <Row>
        <Row className="wrap-add-new">
          <Col span={2}>
            <span className="title-box-add-new">User Id</span>
          </Col>
          <Col span={4}>
            <Input onChange={this.onChangeUserId} />
          </Col>
          <Col span={4}>
            <Button
              type="primary"
              onClick={() => this.onAssignNewMember()}
              loading={isLoadingAddNewMember}
            >
              Assign
            </Button>
          </Col>
        </Row>
      </Row>
    );
  }

  private onChangeUserId = (event: React.ChangeEvent<HTMLInputElement>) => {
    this._withInjectedProps.listingDetail.onChangeNewUserIdAssign(
      Number(event.target.value)
    );
  };

  private onAssignNewMember() {
    this._withInjectedProps.listingDetail.assignMember();
  }

  private _loading() {
    return (
      <div style={{margin: 'auto', minHeight: 300}}>
        <Button shape="circle" type="primary" loading={true} />
      </div>
    );
  }

  private _renderBasicInfo(listing: any) {
    const {team} = this._withInjectedProps.listingDetail;
    return (
      <Row>
        <Col span={5}>
          <Avatar
            shape="square"
            size={100}
            src={listing.images.length > 0 ? listing.images[0].url : ''}
          />
        </Col>

        <Col span={19}>
          <p>
            <b>{listing.name}</b>
          </p>
          <p style={{color: '#ffe58f'}}>{listing.internalName}</p>
          <p style={{color: 'rgb(255, 163, 158)'}}>{listing.source}</p>
          <p>{listing.address}</p>
          <p>
            Team:
            <Link to={`/teams/${team ? team.id : undefined}`}>
              {team ? team.name : 'Loading...'}
            </Link>
          </p>
        </Col>
      </Row>
    );
  }

  private _cvtDataMembers(members: any) {
    const membersListing = Array.from(members.values());
    return membersListing.map((member: any, idex: number) => {
      return this._itemMemberTable(member);
    });
  }

  private _itemMemberTable(member: any) {
    const {id, firstName, lastName, avatar, role, email} = member;
    return {
      key: id,
      id: id,
      avatar: <Avatar shape="square" src={avatar} />,
      name: `${firstName} ${lastName}`,
      email: email,
      role: role ? role.name : 'Not found',

      actions: (
        <Popconfirm
          title="Are you sure delete this member?"
          okText="Yes"
          cancelText="No"
          onConfirm={() => this.onDeleteMemberListing(id)}
        >
          <Button type="danger" size="small" icon="delete" />
        </Popconfirm>
      )
    };
  }

  private _dataHeaderTableMembers() {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Avatar',
        dataIndex: 'avatar',
        key: 'avatar'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: 'Role',
        dataIndex: 'role',
        key: 'role'
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email'
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions'
      }
    ];
  }

  private onDeleteMemberListing(userId: number) {
    this._withInjectedProps.listingDetail.removeMember(userId);
  }
}

export default ListingDetail;



// WEBPACK FOOTER //
// ./src/pages/ListingDetail/ListingDetail.tsx